const firebaseConfig = {
    apiKey: "AIzaSyBTaZqp_v01t4YZ5np77_oyZtvQOmmuOlo",
    authDomain: "care-n-cure-hospital.firebaseapp.com",
    projectId: "care-n-cure-hospital",
    storageBucket: "care-n-cure-hospital.appspot.com",
    messagingSenderId: "761102349273",
    appId: "1:761102349273:web:de9f33149fd169fbcb5fc8"
};
export default firebaseConfig;